const BOOKING_WIDGET_ACTIONS = {
  SET_EXPANDED_TAB: 'BOOKING_WIDGET_ACTIONS/SET_EXPANDED_TAB',
};

export default {
  BOOKING_WIDGET_ACTIONS,
};
